/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import {
  AuditOutlined,
  CodeOutlined,
  TabletOutlined,
  ReloadOutlined,
  SyncOutlined,
  MessageOutlined,
  DashboardOutlined,
} from '@ant-design/icons';
import {
  Button,
  Tabs,
  Input,
  Form,
  Col,
  Row,
  message,
  Progress,
  Modal,
  Tree,
  Empty,
  Select,
  Spin,
  Typography,
} from 'antd';
import { withConfigContext } from '../../../../../../../../components/ConfigContext';
import { MessageList } from 'react-chat-elements';
import 'react-chat-elements/dist/main.css';
import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import swipe from 'jquery-touchswipe';
import axios from 'axios';
import { handleApiError } from '../../../../../../../../services/utils/errorHandler';
import './styles.css';
import BatteryInformationCard from './batteryInformationCard';
import MemoryInformationCard from './memoryInformationCard';
import RamInformationCard from './ramInformationCard';
import WifiInformationCard from './wifiInformationCard';
import MobileDataInformationCard from './mobileDataInformationCard';
import File from './file';
import ServerFile from './serverFile';
import { withTranslation } from 'react-i18next';
const { Search } = Input;

const { Option } = Select;

const { DirectoryTree } = Tree;
const { TabPane } = Tabs;
const { TextArea } = Input;
const { Paragraph } = Typography;

let rsWebsocket;
let screenShareStarted = false;

class DeviceRemoteSession extends React.Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.handleOperation = this.handleOperation.bind(this);
    this.config = this.props.context;
    this.state = {
      connectButtonText: t('label_connectToDevice'),
      image: '',
      deviceConnected: false,
      logcatResponse: '',
      shellResponse: '',
      chatMessageList: [],
      chatMessage: '',
      fileSystem: [],
      key: 0,
      fileOperation: '',
      sereverUrl: '',
      userName: '',
      password: '',
      servers: [],
      serverFiles: [],
      showServerFiles: false,
      serverKey: 0,
      transferServerFile: '',
      serverFileCopied: false,
      transferLocalFile: '',
      localFileCopied: false,
      login: false,
      ftpLoginCredentials: {},
      fileTransfer: false,
      fileTransferPercent: 0,
      search: '',
      filteredFiles: [],
      loading: false,
      device: {},
    };
  }

  initializeRemoteSession = () => {
    const { t } = this.props;
    this.getAccessToken();
    this.setState({
      loading: true,
      connectButtonText: t('label_connectingToDevice'),
    });
  };

  getAccessToken = () => {
    // send request to the invoker
    const { t } = this.props;
    axios
      .get(
        window.location.origin +
          '/entgra-ui-request-handler/default-credentials',
      )
      .then(res => {
        if (res.status === 200) {
          this.initializeRemoteSessionWebSocket(
            res.data.data['default-access-token'],
            res.data.data['remote-session-base-url'],
          );
        }
      })
      .catch(error => {
        handleApiError(error, t('api_getTokenError'), t);
      });
  };

  initializeRemoteSessionWebSocket = (accessToken, websocketUrl) => {
    this.config = this.props.context;
    rsWebsocket = new WebSocket(
      websocketUrl +
        '/' +
        this.props.deviceType +
        '/' +
        this.props.deviceIdentifier +
        '?websocketToken=' +
        accessToken,
    );
    rsWebsocket.onopen = this.remoteSessionWebSocketOnOpen;
    rsWebsocket.onmessage = this.remoteSessionWebSocketOnMessage;
    rsWebsocket.onclose = this.remoteSessionWebSocketOnClose;
    rsWebsocket.onerror = this.remoteSessionWebSocketOnError;
  };

  closeRemoteSession = () => {
    const { t } = this.props;
    rsWebsocket.close();
    this.setState({
      deviceConnected: false,
      connectButtonText: t('label_connectToDevice'),
      chatMessageList: [],
    });
  };

  getServers = () => {
    const { t } = this.props;
    axios
      .get(
        window.location.origin +
          this.config.serverConfig.invoker.uri +
          this.config.serverConfig.invoker.deviceMgt +
          '/configuration',
      )
      .then(res => {
        let serverObj = [];
        res.data.data.configuration.map(server => {
          try {
            const checkServer = JSON.parse(server.value);
            if (checkServer.serverurl) {
              serverObj.push(JSON.parse(server.value));
            }
          } catch {
            message.error(t('api_errorMsg2'));
          }
        });
        this.setState({
          servers: serverObj,
        });
      })
      .catch(err => {
        handleApiError(err, t('api_getFTPServerError'), t);
      });
  };

  displayFileOperationMessage = () => {
    message.info(this.state.fileOperation);
  };

  dispalyFtpServerOperationError = msg => {
    message.error(msg);
  };

  displayFtpServerOperationSuccess = msg => {
    message.success(msg);
  };

  handleOperation = (action, filePath, rename) => {
    const { t } = this.props;
    switch (action) {
      case 'Rename':
        this.renameFile(filePath, rename);
        break;
      case 'Delete':
        this.deleteFile(filePath);
        break;
      case 'Transfer File':
        this.setState(
          {
            transferLocalFile: filePath,
            localFileCopied: true,
          },
          () => {
            message.success(t('api_fileSelectedMsg'), 1);
            this.connect(this.state.ftpLoginCredentials);
          },
        ); // eslint-disable-next-line no-fallthrough
      default:
        break;
    }
  };

  fileSystemConversion = files => {
    const file = {};
    var key;
    if (files.type === 'Folder') {
      const subfiles = [];
      file.key = this.state.key;
      file.isLeaf = false;
      file.name = files.fileName;
      file.type = files.type;
      file.title = (
        <File
          title={files.fileName}
          type={files.type}
          size={files.size}
          lastModified={files.lastModified}
          filePath={files.filePath}
          onSelectOperation={this.handleOperation}
          saveLocalFilePath={this.saveLocalFilePath}
          serverFileCopied={this.state.serverFileCopied}
          login={this.state.login}
        />
      );
      key = this.state.key + 1;
      this.setState({ key });
      files.subfiles.forEach(file => {
        subfiles.push(this.fileSystemConversion(file));
      });
      file.filePath = files.filePath;
      file.children = subfiles;
    } else {
      file.key = this.state.key;
      file.isLeaf = true;
      file.name = files.fileName;
      file.type = files.type;
      file.filePath = files.filePath;
      file.title = (
        <File
          title={files.fileName}
          size={files.size}
          type={files.type}
          lastModified={files.lastModified}
          filePath={files.filePath}
          onSelectOperation={this.handleOperation}
          saveLocalFilePath={this.saveLocalFilePath}
          serverFileCopied={this.state.serverFileCopied}
          login={this.state.login}
        />
      );
      key = this.state.key + 1;
      this.setState({ key });
    }
    return file;
  };

  serverFileConversion = files => {
    const file = {};
    var serverKey;
    if (files.type === 'Folder') {
      const subfiles = [];
      file.key = this.state.serverKey;
      file.isLeaf = false;
      file.title = (
        <ServerFile
          title={files.fileName}
          type={files.type}
          size={files.size}
          filePath={files.filePath}
          transferServerFile={this.transferServerFile}
          localFileCopied={this.state.localFileCopied}
          saveServerFile={this.saveServerFile}
        />
      );
      serverKey = this.state.serverKey + 1;
      this.setState({ serverKey });
      files.subfiles.forEach(file => {
        subfiles.push(this.serverFileConversion(file));
      });
      file.children = subfiles;
    } else {
      file.key = this.state.serverKey;
      file.isLeaf = true;
      file.title = (
        <ServerFile
          title={files.fileName}
          type={files.type}
          size={files.size}
          filePath={files.filePath}
          transferServerFile={this.transferServerFile}
          localFileCopied={this.state.localFileCopied}
          saveServerFile={this.saveServerFile}
        />
      );
      serverKey = this.state.serverKey + 1;
      this.setState({ serverKey });
    }
    return file;
  };

  transferServerFile = filePath => {
    const { t } = this.props;
    this.setState(
      {
        transferServerFile: filePath,
        serverFileCopied: true,
        loading: true,
      },
      () => {
        message.success(t('api_fileSelectedMsg'), 1);
        this.getFileSystem();
        this.setState({
          loading: false,
        });
      },
    );
  };

  saveLocalFilePath = filePath => {
    this.setState(
      {
        fileTransfer: true,
        fileTransferPercent: 10,
      },
      () => {
        this.downloadService(this.state.transferServerFile, filePath);
        this.setState(
          {
            fileTransferPercent: 20,
          },
          () => {
            this.wait(500);
            this.setState(
              {
                fileTransferPercent: 60,
              },
              () => {
                this.wait(300);
                this.getFileSystem();
                this.setState(
                  {
                    fileTransferPercent: 100,
                  }, // eslint-disable-next-line max-nested-callbacks
                  () => {
                    this.setState({
                      transferServerFile: '',
                      serverFileCopied: false,
                      fileTransfer: false,
                    });
                  },
                );
              },
            );
          },
        );
      },
    );
  };

  saveServerFile = filePath => {
    this.setState(
      {
        fileTransfer: true,
        fileTransferPercent: 10,
      },
      () => {
        this.uploadService(filePath, this.state.transferLocalFile);
        this.setState(
          {
            fileTransferPercent: 20,
          },
          () => {
            this.wait(500);
            this.connect(this.state.ftpLoginCredentials);
            this.setState(
              {
                fileTransferPercent: 100,
              },
              () => {
                this.setState({
                  transferLocalFile: '',
                  localFileCopied: false,
                  fileTransfer: false,
                });
              },
            );
          },
        );
      },
    );
  };

  wait(ms) {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }

  remoteSessionWebSocketOnOpen = () => {};

  // eslint-disable-next-line complexity
  remoteSessionWebSocketOnMessage = message => {
    this.setState({
      loading: false,
      deviceConnected: true,
    });
    if (typeof message.data !== 'string') {
      var url = URL.createObjectURL(event.data);
      var img = new Image();
      img.onload = function() {
        var ctx = document.getElementById('canvas').getContext('2d');
        ctx.canvas.height = this.height;
        ctx.canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        URL.revokeObjectURL(url);
      };
      img.src = url;
    } else {
      var json = JSON.parse(message.data);
      if (json.code === 'REMOTE_SHELL') {
        if (json.status !== 'NEW') {
          // $('#loading-terminal').addClass('hidden');
        }
        if (json.operationResponse != null) {
          const shellResponse =
            this.state.shellResponse + json.operationResponse;
          this.setState({ shellResponse });
        }
      } else if (json.code === 'REMOTE_LOGCAT') {
        if (json.operationResponse != null) {
          const logcatResponse =
            this.state.logcatResponse + json.operationResponse;
          this.setState({ logcatResponse });
        }
      } else if (json.code === 'REMOTE_CONNECT') {
        $('#loading-terminal').addClass('hidden');
        if (json.operationResponse != null) {
          const shellResponse =
            this.state.shellResponse + json.operationResponse;
          this.setState({ shellResponse });
        }
      } else if (json.code === 'CHAT') {
        if (json.operationResponse != null) {
          const msg = {
            position: 'left',
            type: 'text',
            text: json.operationResponse,
            date: new Date(),
          };
          let chatMessageList = [...this.state.chatMessageList];
          chatMessageList.push(msg);

          this.setState({ chatMessageList });
        }
      } else if (json.code === 'GET_FILE_SYSTEM') {
        if (json.operationResponse != null) {
          const files = JSON.parse(json.operationResponse);
          const fileSystem = [];
          for (let index = 0; index < files.length; index++) {
            fileSystem.push(this.fileSystemConversion(files[index]));
          }
          this.setState({ fileSystem });
        }
      } else if (json.code === 'DELETE_FILE_FROM_DEVICE') {
        if (json.operationResponse != null) {
          const fileOperation = json.operationResponse;
          this.setState({ fileOperation }, this.displayFileOperationMessage);
          this.getFileSystem();
        }
      } else if (json.code === 'RENAME_FILE') {
        if (json.operationResponse != null) {
          const fileOperation = json.operationResponse;
          this.setState({ fileOperation }, this.displayFileOperationMessage);
          this.getFileSystem();
        }
      } else if (json.code === 'CONNECT_SERVER') {
        if (json.operationResponse != null) {
          try {
            const serverFiles = JSON.parse(json.operationResponse);
            const server = [];
            for (let index = 0; index < serverFiles.length; index++) {
              server.push(this.serverFileConversion(serverFiles[index]));
            }
            this.displayFtpServerOperationSuccess(
              'Connected Successfully to ' +
                this.state.ftpLoginCredentials.serverurl,
            );
            this.setState(
              {
                serverFiles: server,
              },
              () => {
                this.setState(
                  {
                    showServerFiles: true,
                    login: true,
                    loading: false,
                  },
                  () => {
                    this.getFileSystem();
                  },
                );
              },
            );
          } catch {
            this.dispalyFtpServerOperationError(json.operationResponse);
          }
        }
      } else if (json.code === 'DOWNLOAD_SERVICE') {
        if (json.operationResponse != null) {
          if (json.operationResponse === 'File Transfer Completed') {
            this.displayFtpServerOperationSuccess(json.operationResponse);
          } else {
            this.dispalyFtpServerOperationError(json.operationResponse);
          }
        }
      } else if (json.code === 'LIVE_FEED') {
        console.log('recieved...');
        if (json.operationResponse != null) {
          const device = JSON.parse(json.operationResponse);
          const networkData = JSON.parse(device.NetworkDataInfo);
          const dataUsageHistory = JSON.parse(device.Data);

          device.WIFI_SIGNAL_STRENGTH = networkData[2].value;
          device.MOBILE_SIGNAL_STRENGTH = networkData[3].value;
          device.dailyMobileData = dataUsageHistory.dailyMobileData;
          device.dailyWifiData = dataUsageHistory.dailyWifiData;
          device.hourlyMobileData = dataUsageHistory.hourlyMobileData;
          device.hourlyWifiData = dataUsageHistory.hourlyWifiData;
          this.setState({ device });
        }
      }
    }
  };

  remoteSessionWebSocketOnClose = message => {};

  remoteSessionWebSocketOnError = message => {};

  startScreenShare = () => {
    screenShareStarted = true;
    let message = {};
    let input = {};
    input.action = 'start';
    input.height = 768;
    input.width = 1024;
    message.code = 'REMOTE_SCREEN';
    message.payload = JSON.stringify(input);
    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(message));
  };

  stopScreenShare = () => {
    screenShareStarted = false;
    var canvas = document.getElementById('canvas');
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    let message = {};
    let input = {};
    input.action = 'stop';
    message.code = 'REMOTE_SCREEN';
    message.payload = JSON.stringify(input);
    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(message));
    document.removeEventListener('keypress', this.onKeyPress, false);
  };

  startRemoteKeyboard = () => {
    let message = {};
    let input = {};
    input.actionKeyboard = true;
    message.code = 'REMOTE_INPUT';
    message.payload = JSON.stringify(input);
    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(message));
    document.addEventListener('keypress', this.onKeyPress, false);
  };

  onKeyPress = e => {
    let inputMessage = {};
    let input = {};
    input.keyCode = e.keyCode;
    inputMessage.code = 'REMOTE_INPUT';
    inputMessage.payload = JSON.stringify(input);
    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(inputMessage));
  };

  onShellCommandPressEnter = e => {
    var message = {};
    message.code = 'REMOTE_SHELL';
    message.payload = e.target.value;
    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(message));
  };

  deleteFile = filePath => {
    var fileMessage = {};
    fileMessage.code = 'DELETE_FILE_FROM_DEVICE';
    fileMessage.payload = filePath;
    rsWebsocket.send(JSON.stringify(fileMessage));
  };

  renameFile = (filePath, rename) => {
    var fileMessage = {};
    var file = {};
    fileMessage.code = 'RENAME_FILE';
    file.filePath = filePath;
    file.rename = rename;
    fileMessage.payload = file;
    rsWebsocket.send(JSON.stringify(fileMessage));
  };

  connect = values => {
    if (!values.username && !values.password) {
      values.username = 'anonymous';
      values.password = 'anonymous';
    }
    this.setState({
      ftpLoginCredentials: values,
      loading: true,
    });
    var message = {};
    message.code = 'CONNECT_SERVER';
    message.payload = values;
    rsWebsocket.send(JSON.stringify(message));
  };

  downloadService = (ServerFile, LocalFile) => {
    var message = {};
    var download = {};
    message.code = 'DOWNLOAD_SERVICE';
    download.serverFile = ServerFile;
    download.localFile = LocalFile;
    message.payload = download;
    rsWebsocket.send(JSON.stringify(message));
  };

  uploadService = (serverFile, localFile) => {
    var message = {};
    var upload = {};
    message.code = 'UPLOAD_SERVICE';
    upload.serverFile = serverFile;
    upload.localFile = localFile;
    message.payload = upload;
    rsWebsocket.send(JSON.stringify(message));
  };

  wait = ms => {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
    this.startLiveFeed();
  };

  startLiveFeed = () => {
    var message = {};
    message.code = 'LIVE_FEED';
    // Send the message through the WebSocket
    rsWebsocket.send(JSON.stringify(message));
  };

  refreshLogcat = () => {
    var message = {};
    message.code = 'REMOTE_LOGCAT';
    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(message));
  };

  handleCancel = e => {
    this.setState({
      showServerFiles: false,
    });
  };

  handleOk = e => {
    this.setState({
      showServerFiles: false,
    });
  };

  chatMessage = '';

  sendChatMessage = () => {
    var message = {};
    message.code = 'CHAT';
    message.payload = this.chatMessage;

    // Send the message through the WebSocket.
    rsWebsocket.send(JSON.stringify(message));
    const msg = {
      position: 'right',
      type: 'text',
      text: this.chatMessage,
      date: new Date(),
    };
    let chatMessageList = [...this.state.chatMessageList];
    chatMessageList.push(msg);

    this.inputRef.current.value = '';

    this.setState({ chatMessageList });
  };

  getFileSystem = () => {
    var message = {};
    message.code = 'GET_FILE_SYSTEM';
    // send the message through webSocket
    rsWebsocket.send(JSON.stringify(message));
  };

  onBlurChatInput = e => {
    this.chatMessage = e.target.value;
  };

  onFinish = values => {
    var message = {};
    message.code = 'CHAT';
    message.payload = values.message;
    // Check message is there to send message
    if (values.message) {
      // Send the message through the WebSocket.
      rsWebsocket.send(JSON.stringify(message));
      const msg = {
        position: 'right',
        type: 'text',
        text: values.message,
        date: new Date(),
        backgroundColor: 'yellow',
      };
      let chatMessageList = [...this.state.chatMessageList];
      chatMessageList.push(msg);
      this.formRef.current.resetFields();
      this.setState({ chatMessageList });
    }
  };

  componentWillUnmount() {
    const { t } = this.props;
    if (this.state.deviceConnected) {
      rsWebsocket.close();
      this.setState({
        deviceConnected: false,
        connectButtonText: t('label_connectToDevice'),
        chatMessageList: [],
      });
    }
  }

  getHeader(globalFilterKey) {
    const { t } = this.props;
    return (
      <div className="p-text-right">
        <div className="p-input-icon-left">
          <i className="pi pi-search"></i>
          {/* eslint-disable-next-line react/jsx-no-undef */}
          <InputText
            type="search"
            onInput={e =>
              this.setState({ [`${globalFilterKey}`]: e.target.value })
            }
            placeholder={t('form_searchGlobal')}
            size="50"
          />
        </div>
      </div>
    );
  }

  refreshFiles = () => {
    this.getFileSystem();
  };

  resetServer = () => {
    this.setState(
      {
        serverFiles: [],
        login: false,
      },
      this.getFileSystem(),
    );
  };

  updateSearchValue = evt => {
    this.setState({
      search: evt.target.value,
    });
  };

  filterFile = file => {
    if (file.name.toLowerCase().includes(this.state.search.toLowerCase())) {
      return file;
    } else if (file.type === 'Folder' && file.children.length) {
      for (let index = 0; index < file.children.length; index++) {
        if (
          file.children[index].name
            .toLowerCase()
            .includes(this.state.search.toLowerCase())
        ) {
          return this.filterFile(file.children[index]);
        }
      }
    }
  };

  render() {
    let isRemoved = false;
    if (this.props.deviceStatus === 'REMOVED') {
      isRemoved = true;
    }
    const { t } = this.props;
    const {
      loading,
      connectButtonText,
      deviceConnected,
      logcatResponse,
      shellResponse,
      chatMessageList,
    } = this.state;
    var lastDuration = 0;
    var minDuration = 50;
    var durationDiff = 0;
    var status = 'ready';
    var bounds, x, y;
    let endX;
    let endY;
    $(() => {
      $('#canvas').swipe({
        swipeStatus: function(
          event,
          phase,
          direction,
          distance,
          duration,
          fingers,
          fingerData,
          currentDirection,
        ) {
          if (deviceConnected) {
            bounds = event.target.getBoundingClientRect();
            if (phase === 'start' || phase === 'move') {
              x = event.clientX - bounds.left;
              y = event.clientY - bounds.top;
            }
            durationDiff = duration - lastDuration;
            if (x < 0 || y < 0 || status === 'blocked') {
              return;
            }
            var inputMessage = {};
            var input = {};
            input.x = x / bounds.width;
            input.y = y / bounds.height;
            input.duration = durationDiff;
            inputMessage.code = 'REMOTE_INPUT';

            if (status === 'ready' && phase === 'start') {
              endX = input.x;
              endY = input.y;
              input.action = 'down';
              inputMessage.payload = JSON.stringify(input);
              rsWebsocket.send(JSON.stringify(inputMessage));
              status = 'unblocked';
            } else if (status === 'unblocked') {
              if (phase === 'move') {
                if (durationDiff < minDuration) {
                  return;
                }
                endX = input.x;
                endY = input.y;
                input.action = 'move';
                inputMessage.payload = JSON.stringify(input);
                rsWebsocket.send(JSON.stringify(inputMessage));
                lastDuration = duration;
              } else {
                input.x = endX;
                input.y = endY;
                input.action = 'up';
                lastDuration = 0;
                status = 'blocked';
                if (durationDiff < minDuration) {
                  setTimeout(function() {
                    inputMessage.payload = JSON.stringify(input);
                    rsWebsocket.send(JSON.stringify(inputMessage));
                    status = 'ready';
                  }, minDuration);
                } else {
                  inputMessage.payload = JSON.stringify(input);
                  rsWebsocket.send(JSON.stringify(inputMessage));
                  status = 'ready';
                }
              }
            }
          }
        },
      });
    });

    const callBack = key => {
      this.props.hide(key);
      this.getFileSystem();
      this.getServers();
      this.startLiveFeed();
    };

    const onChange = value => {
      {
        this.state.servers.map(server => {
          if (server.serverurl === value) {
            this.connect(server);
          }
        });
      }
    };

    let filteredFiles = this.state.fileSystem.filter(file => {
      let fileFound = this.filterFile(file);
      return fileFound;
    });

    return (
      <div style={{ textAlign: 'left' }}>
        <div className="wrap">
          <Paragraph>{t('remoteView_Txt')}</Paragraph>
        </div>
        <Button
          onClick={this.initializeRemoteSession}
          style={{ display: !deviceConnected ? 'inline' : 'none' }}
          loading={loading}
          disabled={isRemoved}
        >
          {connectButtonText}
        </Button>
        {/* <img src={image} />*/}
        <div style={{ display: deviceConnected ? 'inline' : 'none' }}>
          <Tabs
            tabBarExtraContent={
              <Button onClick={this.closeRemoteSession}>
                {t('label_closeSession')}
              </Button>
            }
            onChange={callBack}
          >
            <TabPane
              key="1"
              tab={
                <span>
                  <TabletOutlined />
                  {t('label_screenShare')}
                </span>
              }
            >
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                <Row>
                  <Col>
                    <Button
                      onClick={
                        !screenShareStarted
                          ? this.startScreenShare
                          : this.stopScreenShare
                      }
                      style={{
                        display: deviceConnected ? 'inline' : 'none',
                        marginBottom: 10,
                      }}
                    >
                      {!screenShareStarted
                        ? t('label_startScreenShare')
                        : t('label_stopScreenShare')}
                    </Button>
                  </Col>
                  {screenShareStarted && (
                    <Col style={{ marginLeft: 10 }}>
                      <Button
                        onClick={this.startRemoteKeyboard}
                        style={{
                          marginBottom: 10,
                        }}
                      >
                        {t('startRemoteKeyboard_Txt')}
                      </Button>
                    </Col>
                  )}
                </Row>
                <div>
                  <canvas
                    style={{
                      display: screenShareStarted ? 'inline' : 'none',
                    }}
                    id="canvas"
                  />
                </div>
              </div>
            </TabPane>
            <TabPane
              key="2"
              tab={
                <span>
                  <CodeOutlined />
                  {t('label_remoteShell')}
                </span>
              }
            >
              <Input
                id={'command-input'}
                autoFocus={true}
                style={{ backgroundColor: '#5f5f5f', color: '#fff' }}
                placeholder={t('form_writeShellCMD')}
                onPressEnter={this.onShellCommandPressEnter}
              />
              <div
                style={{
                  marginTop: 5,
                }}
              >
                <TextArea
                  id={'shell-output'}
                  readOnly={true}
                  style={{
                    backgroundColor: '#5f5f5f',
                    color: '#fff',
                    height: 500,
                  }}
                  value={shellResponse}
                />
              </div>
            </TabPane>
            <TabPane
              key="3"
              tab={
                <span>
                  <AuditOutlined />
                  {t('label_logcat')}
                </span>
              }
            >
              <div>
                <Button onClick={this.refreshLogcat}>
                  {t('label_refreshLogcat')}
                </Button>
                <TextArea
                  readOnly={true}
                  style={{
                    height: 500,
                    marginTop: 5,
                  }}
                  value={logcatResponse}
                />
              </div>
            </TabPane>
            <TabPane
              key="4"
              tab={
                <span>
                  <MessageOutlined />
                  {t('label_chat')}
                </span>
              }
            >
              <div>
                <Col span={22} offset={1}>
                  <div
                    style={{
                      border: 'solid',
                      borderRadius: 5,
                      borderWidth: 1,
                      borderColor: '#F3F3F3',
                    }}
                  >
                    <div style={{ backgroundColor: '#F3F3F3' }}>
                      <MessageList
                        className="message-list"
                        lockable={true}
                        toBottomHeight={'100%'}
                        dataSource={chatMessageList}
                      />
                    </div>
                    <Form
                      ref={this.formRef}
                      name="basic"
                      initialValues={{ remember: true }}
                      onFinish={this.onFinish}
                      size={'large'}
                    >
                      <Row>
                        <Col span={18}>
                          <Form.Item
                            style={{
                              width: '100%',
                            }}
                            name="message"
                          >
                            <Input
                              style={{
                                border: 'none',
                                borderRadius: 0,
                              }}
                              placeholder={t('form_typeMsg')}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item>
                            <Button
                              type="primary"
                              style={{
                                backgroundColor: '#ffffff',
                                color: '#2196F3',
                                border: 'none transparent',
                                boxShadow: 'none',
                                borderRadius: 0,
                                width: '100%',
                              }}
                              htmlType="submit"
                            >
                              {t('title_send')}
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Col>
              </div>
            </TabPane>
            <TabPane
              key="5"
              tab={
                <span>
                  <AuditOutlined />
                  {t('label_fileSystem')}
                </span>
              }
            >
              <div style={{ marginTop: '5%' }}>
                <Row style={{ marginTop: '5%' }}>
                  <Col
                    xs={24}
                    xl={12}
                    style={{ border: '0.1px solid black', borderWidth: 'thin' }}
                  >
                    <Row>
                      <div
                        style={{
                          width: '100%',
                          backgroundColor: 'rgb(227,227,227)',
                        }}
                      >
                        <h1 style={{ textAlign: 'center' }}>
                          {t('label_localFiles')}
                        </h1>
                      </div>
                    </Row>
                    <Row>
                      <div
                        style={{
                          width: '100%',
                          backgroundColor: 'rgb(227,227,227)',
                          height: 70,
                          paddingTop: '2%',
                          display: 'flex',
                        }}
                      >
                        <Search
                          placeholder={t('form_searchLocalFiles')}
                          style={{ width: '50%', height: 30, marginLeft: '2%' }}
                          onChange={evt => this.updateSearchValue(evt)}
                          value={this.state.search}
                        />
                        <Button
                          type="primary"
                          icon={<ReloadOutlined />}
                          size="middle"
                          onClick={this.refreshFiles}
                          style={{ marginLeft: '7%' }}
                        >
                          {t('label_refresh')}
                        </Button>
                      </div>
                    </Row>
                    <div style={{ width: '100%' }}>
                      <Row
                        style={{
                          fontSize: '13px',
                          backgroundColor: 'rgb(227,227,227)',
                          fontWeight: 'bold',
                        }}
                      >
                        <Col span={2} style={{ marginLeft: '5%' }}>
                          {t('label_name')}Name
                        </Col>
                        <Col span={2} style={{ marginLeft: '25%' }}>
                          {t('label_size')}Size
                        </Col>
                        <Col span={4} style={{ marginLeft: '6%' }}>
                          {t('label_lastModified')}
                        </Col>
                        <Col span={3} style={{ marginLeft: '11%' }}>
                          {t('label_actions')}
                        </Col>
                      </Row>
                      <Row>
                        <div style={{ width: '100%' }}>
                          {filteredFiles.length ? (
                            <DirectoryTree
                              multiple
                              defaultExpandAll
                              treeData={filteredFiles}
                            />
                          ) : (
                            <Empty
                              description={
                                <span>{t('noDeviceFiles_Txt')}</span>
                              }
                            />
                          )}
                        </div>
                      </Row>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    xl={12}
                    style={{ border: '0.1px solid black', borderWidth: 'thin' }}
                  >
                    <Row>
                      <div
                        style={{
                          width: '100%',
                          backgroundColor: 'rgb(227,227,227)',
                        }}
                      >
                        <h1 style={{ textAlign: 'center' }}>
                          {t('label_serverFiles')}
                        </h1>
                      </div>
                    </Row>
                    <Row>
                      <div
                        style={{
                          width: '100%',
                          backgroundColor: 'rgb(227,227,227)',
                          height: 70,
                          paddingTop: '2%',
                          display: 'flex',
                        }}
                      >
                        <Button
                          type="primary"
                          icon={<SyncOutlined />}
                          size="middle"
                          onClick={this.resetServer}
                          style={{ marginLeft: '10%' }}
                        >
                          {t('label_resetServer')}
                        </Button>
                      </div>
                    </Row>
                    <Spin
                      tip={t('label_connecting')}
                      spinning={this.state.loading}
                    >
                      <div style={{ width: '100%' }}>
                        <Row
                          style={{
                            fontSize: '13px',
                            backgroundColor: 'rgb(227,227,227)',
                            fontWeight: 'bold',
                          }}
                        >
                          <Col span={2} style={{ marginLeft: '5%' }}>
                            {t('label_name')}
                          </Col>
                          <Col span={2} style={{ marginLeft: '33%' }}>
                            {t('label_size')}
                          </Col>
                          <Col span={3} style={{ marginLeft: '23%' }}>
                            {t('label_actions')}
                          </Col>
                        </Row>
                        <Row>
                          <div style={{ width: '100%' }}>
                            {/* eslint-disable-next-line no-nested-ternary */}
                            {this.state.servers.length ? (
                              this.state.serverFiles.length ? (
                                <DirectoryTree
                                  multiple
                                  defaultExpandAll
                                  treeData={this.state.serverFiles}
                                />
                              ) : (
                                <div
                                  style={{
                                    justifyContent: 'center',
                                    marginTop: '50%',
                                    marginLeft: '35%',
                                  }}
                                >
                                  <h1 style={{ marginLeft: '9%' }}>
                                    {t('title_selectServer')}
                                  </h1>
                                  <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder={t('form_selectServer')}
                                    optionFilterProp="children"
                                    onChange={onChange}
                                  >
                                    {this.state.servers.map(server => {
                                      return (
                                        <Option
                                          value={server.serverurl}
                                          key={server.serverurl}
                                        >
                                          {server.serverurl}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </div>
                              )
                            ) : (
                              <Empty
                                description={
                                  <span style={{ fontWeight: 'bold' }}>
                                    <a href="/endpoint-mgt/configurations/platform-configuration/general-config/add-server">
                                      {t('addServer_Txt')}
                                    </a>
                                  </span>
                                }
                                style={{ marginTop: '25%' }}
                              />
                            )}
                          </div>
                        </Row>
                      </div>
                    </Spin>
                  </Col>
                </Row>
                <Modal
                  title={t('label_transferring')}
                  open={this.state.fileTransfer}
                  okButtonProps={{ disabled: true }}
                  cancelButtonProps={{ disabled: true }}
                >
                  {this.state.fileTransferPercent ? (
                    <Progress
                      percent={this.state.fileTransferPercent}
                      status="active"
                    />
                  ) : null}
                </Modal>
                <div></div>
              </div>
            </TabPane>
            <TabPane
              key="6"
              tab={
                <span>
                  <DashboardOutlined />
                  {t('label_liveFeed')}
                </span>
              }
            >
              <Row>
                <Col span={24}>
                  <BatteryInformationCard
                    health={this.state.device.Health}
                    temperature={this.state.device.Temp}
                    level={this.state.device.Level}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Col xl={12} xs={24}>
                  <MemoryInformationCard
                    memoryType={t('label_internalMemory')}
                    totalMemory={this.state.device.TotalInternalMemory}
                    availableMemory={this.state.device.AvailableInternalMemory}
                  />
                </Col>
                <Col xl={12} xs={24}>
                  <MemoryInformationCard
                    memoryType={t('label_externalMemory')}
                    totalMemory={this.state.device.TotalExternalMemory}
                    availableMemory={this.state.device.AvailableExternalMemory}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Col span={24}>
                  <RamInformationCard
                    totalRam={this.state.device.TotalRam}
                    availableRam={this.state.device.AvailableRam}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Col span={24}>
                  <WifiInformationCard
                    signalStrength={this.state.device.WIFI_SIGNAL_STRENGTH}
                    dailyWifiData={this.state.device.dailyWifiData}
                    hourlyWifiData={this.state.device.hourlyWifiData}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Col span={24}>
                  <MobileDataInformationCard
                    signalStrength={this.state.device.MOBILE_SIGNAL_STRENGTH}
                    dailyMobileData={this.state.device.dailyMobileData}
                    hourlyMobileData={this.state.device.hourlyMobileData}
                  />
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default withConfigContext(withTranslation()(DeviceRemoteSession));
